module.exports = __webpack_public_path__ + "media/images/icook-logo-g@2x-5f5509f931d077c825be5025b4ec2d55.png";